import { Component } from '@verndale/core'

class Masthead extends Component {
  setupDefaults() {
    this.dom = {
      copy: this.el.querySelector('.masthead-copy'),
      link: this.el.querySelector('.masthead-cta'),
      expandableCopy: this.el.dataset.expandableCopy,
      select: this.el.querySelector('.masthead__select'),
      panels: this.el.querySelectorAll('.office-detail')
    }

    const country = this.el.dataset.country;
    if (country && this.dom.select) {
      let panelId = null;
      Array.from(this.dom.select.options).forEach((element) => {
        if (element.value === country) {
          panelId = element.value;
        }
      });
      this.dom.select.value = panelId;
    }

    Array.from(this.dom.panels).map((panel) => {
      if (this.dom.select.value === panel.dataset.panelValue) {
        panel.style.display = 'flex'
      }
    })
    this.makeCopyExpandable()
  }

  addListeners() {
    this.dom.select?.addEventListener('change', this.selectPanels.bind(this))
  }

  selectPanels(e) {
    const panels = this.el.querySelectorAll('.office-detail')
    Array.from(panels).map((panel) => {
      if (e.target.value === panel.dataset.panelValue) {
        panel.style.display = 'flex'
      } else {
        panel.style.display = 'none'
      }
    })
  }
  makeCopyExpandable() {
    if (this.el.classList.contains('masthead--expandable') && this.dom.expandableCopy === 'true') {
      const parentDiv = this.dom.copy.parentElement
      this.readMoreButton = document.createElement('button')
      this.readMoreButton.classList.add('masthead-expandable-button')
      this.readMoreButton.innerText = this.el.dataset.readMoreLabel
      if (this.dom.link) {
        parentDiv.insertBefore(this.readMoreButton, this.dom.link)
      } else {
        parentDiv.append(this.readMoreButton)
      }
      this.readMoreButton.addEventListener('click', this.handleReadMore.bind(this))
      this.dom.copy.classList.add('masthead-expandable-copy')
    }
  }

  handleReadMore() {
    if (this.dom.copy.classList.contains('masthead-expandable-copy')) {
      this.dom.copy.classList.remove('masthead-expandable-copy')
      this.readMoreButton.textContent = this.el.dataset.readLessLabel
    } else {
      this.dom.copy.classList.add('masthead-expandable-copy')
      this.readMoreButton.textContent = this.el.dataset.readMoreLabel
    }
  }
}

export default Masthead
